import { Box, Card } from "@mui/material";

export default function CardSys({ children, ...props }) {
    return (
        <Box {...props}>
            <Card sx={{ background: '#f1f6ff', boxShadow: 'none', borderRadius: "1rem", padding: "16px", height:"100%"}} >
                {children}
            </Card>
        </Box>
    )
}